
import React, { useState } from 'react'

export const DudaCmp = ({ addDuda }) => {
  const [duda, setDuda] = useState('')
  const [cargando, setCargando] = useState(false); 


  function onChangeInput(event) {
    setDuda(event.target.value)
  }

  async function handlerEnviar(duda) {
    setCargando(true); // Inicia el indicador de carga
    try {
      await addDuda(duda) // Suponiendo que esta es la función que guarda la respuesta
      // Operación exitosa
    } catch (error) {
      console.error("Error al guardar la duda", error);
      // Manejo de error
    } finally {
      setCargando(false); // Detiene el indicador de carga independientemente del resultado
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handlerEnviar(event.target.value);
    }
  };

  return (
    <div style={{ marginTop: '-60%'}}>
      <h1 className="text-2xl font-bold mb-10">Alguna duda que quieras aclarar?</h1>
      <div className="flex flex-col items-center">
        
          <textarea className="textarea w-full max-w-m h-28" placeholder="Escribe aquí tu respuesta..." value={duda} onChange={onChangeInput} onKeyDown={handleKeyPress}></textarea>
        
          <button className="btn btn-primary mt-5" onClick={() => handlerEnviar(duda)}>
          {cargando ? <div className="flex items-center">
      <div className="spinner"></div>
      <span className="ml-2">Enviando...</span>
    </div> : 'ENVIAR'} {/* Cambia el texto según el estado de `cargando` */}
        </button>
      </div>
    </div>
  )
}